import { PriceDTO } from "@gymflow/types";

export const getEffectivePrice = (
  item: { price: number; membersOnlyPrice: PriceDTO },
  isMember: boolean,
) =>
  isMember &&
  item.membersOnlyPrice?.price !== undefined &&
  item.membersOnlyPrice?.price !== null
    ? item.membersOnlyPrice.price
    : item.price;
